jQuery(document).ready(function($){

    $('#modal-video').on('open.zf.reveal', function(event) {
        var video = $(this).find('video')[0];

        if (video.paused) {
            video.play();
        }
    });

    $('#modal-video').on('closed.zf.reveal', function(event) {
        var video = $(this).find('video')[0];

        if (!video.paused) {
            video.pause();
        }
    });

});
